module.exports = __webpack_public_path__ + "public/img/no-coupon.46f90f66.png";